import { Provider } from '@angular/core';
import { environment } from 'src/environment/environment';
import { API_BASE_URL, UM_BASE_URL, US_BASE_URL } from './tokens';

export const apiProviders: Provider[] = [
  { provide: API_BASE_URL, useValue: environment.apiBaseUrl },
  { provide: US_BASE_URL, useValue: environment.usBaseUrl },
  { provide: UM_BASE_URL, useValue: environment.umBaseUrl },
];
